const getMessageError = message => {
  let regex = '';
  const messageCodeDefault = 'default';
  const messageClean = cleanMessage(message);

  regex = /paraodiadasemana/g;
  if (isMatch(regex, messageClean) ) { 
    return "gate010";
  }

  regex = /capacidadeinsuficiente/g;
  if (isMatch(regex, messageClean) ) { 
    return "gate011";
  }
 
  regex = /horariocomagendamento/g;
  if (isMatch(regex, messageClean) ) { 
    return "gate012";
  }
 
  regex = /existehorarioagendadoparaoportao/g;
  if (isMatch(regex, messageClean) ) { 
    return 'gate013';
  }

  regex = /cargainsuficiente/g;
  if (isMatch(regex, messageClean) ) { 
    return "gate014";
  }

  regex = /capacidadedinamicanaoalterada/g;
  if (isMatch(regex, messageClean) ) { 
    return "gate015";
  }

  regex = /datajcadastradaparaessecd/g;
  if (isMatch(regex, messageClean) ) { 
    return "cdException010";
  }
  
  regex = /portaonaopossuicapacidade/g;
  if (isMatch(regex, messageClean) ) { 
    return "loadDetails010";
  } 
 
  regex = /nopermitidoainc/g;
  if (isMatch(regex, messageClean) ) { 
    return "loadDetails011";
  }

  regex = /prazomximode28/g;
  if (isMatch(regex, messageClean) ) { 
    return "loadDetails014";
  }

  regex = /prazominimode2/g;
  if (isMatch(regex, messageClean) ) { 
    return "loadDetails015";
  }

  regex = /falhanocancelamento/g;
  if (isMatch(regex, messageClean) ) { 
    return "loadDetails012";
  }

  regex = /horariojapossuiagendamento/g;
  if (isMatch(regex, messageClean) ) { 
    return "loadDetails013";
  }

  regex = /nofoipossveleditarocd/g;
  if (isMatch(regex, messageClean) ) { 
    return 'cdHour010';
  }

  regex = /ocorreuerronageraodaetiqueta/g;
  if (isMatch(regex, messageClean) ) { 
    return 'tag010';
  }

  regex = /noresponsefromdevice/g;
  if (isMatch(regex, messageClean) ) { 
    return 'printer010';
  }

  regex = /nodevice/g;
  if (isMatch(regex, messageClean) ) { 
    return 'printer011';
  }

  regex = /noprinter/g;
  if (isMatch(regex, messageClean) ) { 
    return 'printer012';
  }

  regex=/idfornecedornaoencontrado/g;
  if (isMatch(regex, messageClean) ) { 
    return 'register01';
  }

  regex=/cnpjnaoencontrado/g;
  if (isMatch(regex, messageClean) ) { 
    return 'register02';
  }

  regex=/cadastrorealizadocomsucesso/g;
  if (isMatch(regex, messageClean) ) { 
    return 'register03';
  }

  regex=/cdnaoencontrado/g;
  if (isMatch(regex, messageClean) ) { 
    return 'register04';
  }

  return messageCodeDefault;
}

const cleanMessage = ( message ) => {
  let regex = /[^0-9a-zA-Z]/g; // remove caractere especial
  let newMessage = message.toLowerCase().replace(regex,'');
  return newMessage;
  
}

const isMatch = (regex, message ) => {
  let results =  message.match(regex);

  if (results && results.length > 0) {
    return true
  } else {
    return false
  }

}
  
export default getMessageError;